export default __webpack_public_path__ + "static/media/enhanced.4b89dcf4.jpg";